import {FC} from 'react';
import {Container, IconButton} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import RequestClass from './RequestClass';

interface EditClassProps{
    DialogOpen: any;
    classId: string;
    handleDialogClose: () => void;
    instructor?: any[];
    userType?: string;
    cdiCourses?: any[];
    submitForm?: any;
}

export const EditClass: FC<EditClassProps> = (
    {
        handleDialogClose, classId, userType, cdiCourses, submitForm
    }
): JSX.Element => {
    return (
        <Container
            className='container'
            maxWidth={'lg'}
            sx={{
                minHeight: '300px',
                paddingBottom: '3.5rem',
                paddingTop: '2.5rem',
                position: 'relative'
            }}
        >
            <IconButton
                aria-label='close'
                onClick={handleDialogClose}
                size='large'
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    zIndex: 2
                }}
            >
                <CloseIcon/>
            </IconButton>
            <RequestClass
                cdiCourses={cdiCourses}
                classId={classId}
                requestType={'Edit'}
                setRequestClass={''}
                submitForm={submitForm}
                userType={userType ?? ''}
            />
        </Container>
    );
};
